import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProcessService } from 'src/app/services/process.service';
import { SharedService } from '../../services/sharedService';
import { filterEligibleControls } from '../../utils/control-eligibility';
import { RiskService } from 'src/app/services/riskService';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Company } from 'src/app/entities/company';
import { NgxSpinnerService } from 'ngx-spinner';
import { SourceService } from 'src/app/services/sourceService';

@Component({
  selector: 'app-new-preprocess',
  templateUrl: './new-preprocess.component.html',
  styleUrls: ['./new-preprocess.component.css']
})
export class NewPreprocessComponent implements OnInit {
  @Input()
  modalRef?: BsModalRef;
  creating = false;
  // i18n key of the period-conflict message shown inline in the dialog; null = no alert
  periodErrorKey: string | null = null;
  @Input()
  company?: Company;

  risks$: any[] = [];
  risksLoading = false;
  risksInput$ = new Subject<string>();
  selectedCompany: any;
  controlActivity: any;
  controlexecutive: any;
  dernPeriod: any;
  soumisePeriod: any;
  controlProgSource: any;
  executives$: any[] = [];
  sources$: any[] = [];

  controlTypes$: any[];
  controlTypesLoading = false;
  controlTypesInput$ = new Subject<string>();
  selectedControl: any;
  controlName: any;
  activeRisks: any[];
  process = {}
  @ViewChild('riskMulti', { static: false }) public riskMulti: NgSelectComponent;

  constructor(
    private riskService: RiskService,
    private processService: ProcessService, private sharedService: SharedService,
    private sourceService: SourceService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.riskService.getTotalRiskList().subscribe(risks => {
      this.risks$ = risks;
    })
    this.sourceService.getSourceList().subscribe(sources => {
      this.sources$ = sources;
    })
    this.sourceService.getExecutiveList().subscribe(executives => {
      this.executives$ = executives;
    })
    this.processService.getControlTypeList('').subscribe(resp => {
        this.controlTypes$ = filterEligibleControls(resp, this.company?.taxpayerType);
    });
  }
 
  onSubmit(): void {
    this.periodErrorKey = this.invalidPeriodKey();
    if (this.periodErrorKey) { return; }
    this.spinner.show();
    this.creating = true;
    this.process['type'] = {}
    this.process['company'] = {};
    this.process['company']['id'] = this.company.id;
    this.process['company']['name'] = this.company.company_name;
    this.process['company']['tax_id'] = this.company.tax_id;
    this.process['type']['key'] = this.selectedControl;
    this.process['type']['name'] = this.controlTypes$.find(elem => elem['key']===this.selectedControl).name;
    this.process['risks'] = this.riskMulti['activeItems']

    this.process['activity'] = this.controlActivity
    this.process['performer'] = this.controlexecutive
    // if (this.dernPeriod)
    // this.process['lastPeriod'] = this.getNgbDatepickerIsoDate(this.dernPeriod)

    // if (this.soumisePeriod)
    // this.process['submittedPeriod'] = this.getNgbDatepickerIsoDate(this.soumisePeriod)
    this.process['source'] = this.controlProgSource
    this.processService.addProcess(this.process).pipe(
      // Cleanup on both success and error: the previous code hid the spinner only
      // in the success callback, so a failed create left the spinner stuck forever.
      // The user-facing error toast is handled globally by AuthInterceptor.
      finalize(() => {
        this.spinner.hide();
        this.creating = false;
      })
    ).subscribe({
      next: () => {
        this.modalRef.hide();
        setTimeout(() => {
          this.sharedService.addProcess();
        }, 1000);
      },
      error: (err) => {
        // SharedService.handleError rethrows the response body (error.error), so the
        // code arrives at err.errorCode here; the raw HttpErrorResponse would have it
        // at err.error.errorCode. Accept either shape.
        const errorCode = err?.errorCode ?? err?.error?.errorCode;
        if (errorCode === 'PERIOD_BLOCKED_BY_VGC') {
          // Show an inline alert inside the dialog instead of a floating toast.
          this.periodErrorKey = 'CONTROL-MODULE.PERIOD_BLOCKED_BY_VGC_ERROR';
        } else if (errorCode === 'PERIOD_BLOCKED_NON_VGC') {
          this.periodErrorKey = 'CONTROL-MODULE.PERIOD_BLOCKED_NON_VGC_ERROR';
        } else if (errorCode === 'INVALID_PERIOD') {
          const field = err?.field ?? err?.error?.field;
          this.periodErrorKey = field === 'lastPeriod'
            ? 'CONTROL-MODULE.INVALID_LAST_PERIOD_ERROR'
            : 'CONTROL-MODULE.INVALID_SUBMITTED_PERIOD_ERROR';
        } else if (errorCode) {
          // Unknown coded error: the interceptor suppressed its generic toast for us,
          // so fall back to showing the backend message (translate passes unknown
          // keys through verbatim).
          this.periodErrorKey = err?.message ?? err?.error?.message ?? errorCode;
        }
        // Other errors are already toasted generically by AuthInterceptor.
        // The spinner/creating flag are reset by the existing finalize() above.
      }
    });
  }

  getNgbDatepickerIsoDate(date: any){
     let dateFromDbPicker = new Date(Date.UTC(date['year'], date['month']-1,  date['day'], 0, 0, 0, 0))
     return dateFromDbPicker;
  }

  private static readonly PERIOD_MIN_MS = Date.UTC(1999, 11, 31);

  // Mirror of the backend rule (period-overlap.util.js#invalidPeriodReason):
  // a provided period must be complete, parseable, ordered, and start no
  // earlier than year 2000 (no upper bound). Returns the i18n key, or null.
  private invalidPeriodKey(): string | null {
    const bad = (p: any): boolean => {
      if (p == null) { return false; }
      if (p.fromDate == null || p.toDate == null) { return true; }
      const from = new Date(p.fromDate).getTime();
      const to = new Date(p.toDate).getTime();
      return isNaN(from) || isNaN(to) || from > to
        || from < NewPreprocessComponent.PERIOD_MIN_MS;
    };
    if (bad(this.process['lastPeriod'])) { return 'CONTROL-MODULE.INVALID_LAST_PERIOD_ERROR'; }
    if (bad(this.process['submittedPeriod'])) { return 'CONTROL-MODULE.INVALID_SUBMITTED_PERIOD_ERROR'; }
    return null;
  }

  setDates(res){
    // Changing either period invalidates a previous overlap result; hide the
    // alert until the next submission re-checks.
    this.periodErrorKey = null;
    this.process[res.key] = {}
    this.process[res.key]['fromDate'] = res.fromDate
    this.process[res.key]['toDate'] = res.toDate

  }

}
